import { render, staticRenderFns } from "./IndicatorCard.vue?vue&type=template&id=3c00452f"
import script from "./IndicatorCard.vue?vue&type=script&lang=js"
export * from "./IndicatorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports